import {expandToStructure} from '#core/utils/config-utils.js';

import {configureSportsbook} from '#core/sportsbook-initializer.js';

import {getTokens} from './config/viewsconfig.js';
import translations from './config/translations.l10n.yaml';
import defaultConfig from './config/default-config.yaml';
import fonts from './config/fonts.yaml';
import {THEME} from './config/theme';

configureSportsbook({
    getTokensFn: getTokens,
    configuration: {
        ...defaultConfig,
        ...expandToStructure(THEME),
        translations,
        fonts,
    },
});
